// extracted by mini-css-extract-plugin
export var backdropBlur = "_cm-0";
export var contentCard = "_cm-5";
export var frame = "_cm-2";
export var image = "_cm-4";
export var imagePane = "_cm-3";
export var modal = "_cm-1";